import { render, staticRenderFns } from "./ViewAsset.vue?vue&type=template&id=9d47c3f4&"
import script from "./ViewAsset.vue?vue&type=script&lang=ts&"
export * from "./ViewAsset.vue?vue&type=script&lang=ts&"
import style0 from "./ViewAsset.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports